import React, { useState ,useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import infoLogo from "../../../assets/images/info.png";
import warningLogo from "../../../assets/images/warning.png";
import {FormattedMessage} from "react-intl";

const ModalExample = (props) => {
  const {
    buttonLabel,
    className,
    size,
    warning,
    info,
    confirmation,
    isText,
    hasTitle,
    confirmation_dashboard
  } = props;

  const [modal, setModal] = useState(false);
  const [infoText, setInfoText] = useState("Notification");
  const [warningText, setWarningText] = useState("Change Admin");

  const toggle = (val) => {
    setModal(!modal);
    console.log(modal)
    if(modal){
      console.log("exit!!")
      props.reset();
    }
  }

  const close = ()=>{
    toggle();
    if(props.hasOwnProperty('reset')){
      props.reset();
    }
    if(props.hasOwnProperty('message')){
      if(props.message && props.message.body.msg === "Token Expired"){
        console.log("Token Expired");
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/"
      }
    }
  }

  const closeConfrimation = ()=>{
    toggle();
    props.confirmationSub();
  }

  useEffect(() => {
    if(props.hasOwnProperty('setClick')){
      props.setClick(toggle);
    }
    if(props.hasOwnProperty('infoText')){
      setInfoText(props.infoText);
    }
    if(props.hasOwnProperty('warningText')){
      setWarningText(props.warningText);
    }
  }, []);

  return (

    <i>
      {/*<Button color="danger" onClick={toggle}>{buttonLabel}</Button>*/}
      {isText && (<b style={{color: '#047a93', cursor: 'pointer'}} onClick={toggle}>Click here for offer details</b>)}
      <Modal isOpen={modal} toggle={toggle} className={className} >
          {hasTitle && (
            <ModalHeader toggle={toggle}>
              {(info || confirmation || confirmation_dashboard) &&(<div style={{width: "372px"}}><img alt="SHIFT" src={infoLogo} className="modal_logo"/><i>{infoText}</i> </div>)}
              {warning &&(<div style={{width: "372px"}}><img alt="SHIFT" src={warningLogo} className="modal_logo"/>Release Error </div>)}
            </ModalHeader>
          )}
          <ModalBody>
            <div dangerouslySetInnerHTML={{ __html: props.content }} />
          </ModalBody>
          <ModalFooter>
            {(info || warning) &&(
              <button
                className="button"
                style={{ marginLeft : "auto", marginRight : "auto"}}
                type="button"
                onClick={close}
              >
                <FormattedMessage id="nav.ok" defaultMessage="OK" />
              </button>
            )}
            {confirmation &&(
              <div  className="button-container"
                    style={{ textAlign: 'center',marginLeft:'auto',marginRight:'auto' }}>
                <button
                  className="button"
                  type="button"
                  style={{ marginRight: '40px' }}
                  onClick={close}
                >
                  back
                </button>

                <button
                  className="button"
                  type="button"
                  onClick={closeConfrimation}
                >
                  <FormattedMessage
                    id="submit.button.name"
                    defaultMessage="Submit"
                  />
                </button>
              </div>
            )}
            {confirmation_dashboard &&(
              <div  className="button-container"
                    style={{ textAlign: 'center',marginLeft:'auto',marginRight:'auto' }}>
                <button
                  className="button"
                  type="button"
                  style={{ marginRight: '40px' }}
                  onClick={close}
                >
                  Cancel
                </button>

                <button
                  className="button"
                  type="button"
                  onClick={closeConfrimation}
                >
                  Delete
                </button>
              </div>
            )}

          </ModalFooter>
        </Modal>
    </i>
  );
}

export default ModalExample;



// WEBPACK FOOTER //
// ./src/components/views/BuildCode/pop.js